import React, { Fragment } from 'react'
import RolesEditForm from './RolesEditForm'
import SectionTitle from '../shared/sectionTitle'

const RolesEditScreen = ({ id }) => {
  const actionName = id ? 'Edit' : 'New'

  return (
    <Fragment>
      <div className='mb-3 d-flex justify-content-between align-items-center'>
        <SectionTitle rows={[actionName, 'Role']} />
      </div>
      <div className='card card-robis'>
        <RolesEditForm id={id} />
      </div>
    </Fragment>
  )
}

export default RolesEditScreen
